import type { Product } from '../../../data/product';
import { MissingCaseQtyBadge } from './missing-case-qty-badge';

type Props = {
  product: Product;
};

export function CaseQtyCell({ product }: Props) {
  if (product.case_qty === 0) {
    return <MissingCaseQtyBadge />;
  }

  return <>{product.case_qty}</>;
}
